import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import outputLogoStripes from "assets/images/output-logo-180x180.svg";
import * as Components from "./ChartNoData.components";

interface ChartNoDataProps {
  title: string;
  description: React.ReactNode;
  children?: React.ReactNode;
}

function ChartNoData(props: ChartNoDataProps) {
  const { t } = useTranslation();

  return (
    <ThemeProvider2024>
      <Components.Container>
        <Components.MessageContainer>
          <Components.TitleText variant="TextXL">{props.title}</Components.TitleText>
          <Components.DescriptionText>{props.description}</Components.DescriptionText>
        </Components.MessageContainer>
        {props.children ? (
          props.children
        ) : (
          <Components.LogoContainer>
            <Components.LogoImg src={outputLogoStripes} alt={t("global.logo_stripes_alt_text")} />
          </Components.LogoContainer>
        )}
      </Components.Container>
    </ThemeProvider2024>
  );
}

export default ChartNoData;
